import { Injectable } from '@angular/core';
import { UserService, PWUserService } from './user.service';
import { App, AppService } from './app.service';
import { UtilService } from './util.service';
import { AppInstallService } from './app-install.service';
import { AmplifyControllerService } from './amplify-controller.service';

declare var chrome: any;

@Injectable({
  providedIn: 'root'
})
export class ChromeExtService {
  private licNum: number;
  // private licNumSesKey: string;
  constructor(
    private userService: UserService,
    private utilService: UtilService,
    private appInstallService: AppInstallService,
    private amplifyControllerService: AmplifyControllerService) {
    this.licNum = -1;
    // this.licNumSesKey = 'licNum';
  }

  public async notifyExtToLogIn(curLicNum: number) {
    if (!this.utilService.hasChromeRuntime() || !AppService.isPW())
      return;

    if (this.licNum == curLicNum) {
      this.licNum = curLicNum;
      return;
    }

    const user = this.userService.getUserInfoJsonStrFromLocalStorage();
    const licenses = (<PWUserService>this.userService).getLicenseJsonStrFromLocalStorage();
    const session = await this.amplifyControllerService.getSession();
    console.log("licenses", licenses, session);
    chrome.runtime.sendMessage(
      // environment.chromeExtensionId,
      this.utilService.getEndpoint('chromeExtensionId'),
      { target: 'authLogin', alreadyLoggedIn: true, user, license: licenses.license, pwLicense: licenses.pwLicense, session },
      this.markNotifiedExtLogin.bind(this)
    );
    console.log("runtime.sendMessage login");
  }

  public notifyExtToLogOut() {
    if (!this.utilService.hasChromeRuntime() || !AppService.isPW())
      return;

    chrome.runtime.sendMessage(
      // environment.chromeExtensionId,
      this.utilService.getEndpoint('chromeExtensionId'),
      { target: 'authLogout' },
      this.markNotifiedExtLogout.bind(this)
    );
    console.log("runtime.sendMessage logout");
  }

  private markNotifiedExtLogout(res) {
    if (chrome.runtime.lastError) {
      console.log("lastError logout");
    }
    if (res && res.ok) {
      this.licNum = -1;
    }
  }

  private markNotifiedExtLogin(res) {
    if (chrome.runtime.lastError) {
      console.log("lastError login");
    }
    if (res && res.ok) {
      const license = (<PWUserService>this.userService).getLicenseFromLocalStorage();
      const curLicNum = license.num;
      this.licNum = curLicNum;
    }
  }
}